import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';

import { useCancelRoute } from 'hooks';
import { CreateCategoryForm } from './CreateCategoryForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
  })
);

export const CreateCategoryPage = () => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute('/categories');

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Добавление категории"
      aria-describedby="Используйте эту форму для создания новой категории"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form}>
          <CreateCategoryForm onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
